import { update } from 'lodash'

export default {
  bind(el, binding) {
    const radioAriaEls = el.querySelectorAll('.el-radio__original')
    radioAriaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  },
}
